import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  BasicAccordion,
  Button,
  RecommendationsCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import recommendationsTabMessages from '../../../core-utils/messages/recommendationsTabMessages';
import { useStores } from '../../../stores';
import EmptyData from '../../atoms/Icons/EmptyData';
import RecommendationsInternalScreenPopUp from '../../molecules/RecommendationsInternalScreenPopUp';
import Loader from '../../molecules/Loader';

export interface ActionData {
  action: string;
  typeOfStrategy: string;
  whatYouWantAchieve: string;
}

export interface CategoriesData {
  message: string;
  additionalData: string;
  actions: ActionData[];
}

export interface RecommendationsData {
  category: string;
  categoriesData: CategoriesData[];
}

export interface RecommendationsTabProps {
  isInternalPage?: boolean;
  recommendationLoading?: boolean;
}

const RecommendationsTab: React.FC<RecommendationsTabProps> = ({
  isInternalPage,
  recommendationLoading,
}) => {
  const useStyles = makeStyles()({
    recommendationAccordion: {
      marginBottom: '20px',
    },
    emptyDataIconGrid: {
      marginTop: '200px',
      marginBottom: '24px',
    },
  });

  const messages = recommendationsTabMessages;

  const recommendedTabStore = useStores().recommendedTabStore;
  const [loader] = useState<any>(<Loader />);

  const [
    isRecommendationDataEmpty,
    setIsRecommendationDataEmpty,
  ] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const recommendationsData = recommendedTabStore.recommendationsData;

  const { classes } = useStyles();

  const handleOpenChip = (category: any, categoryName: string) => {
    setOpen(true);
    recommendedTabStore?.setColumnsInRecommendedTable(category?.tableColumns);
    recommendedTabStore?.setDataInRecommendedTable(category?.tableData);
    recommendedTabStore?.setCategoryAdditionalData(category?.additionalData);
    recommendedTabStore?.setCategoryData(categoryName);
  };

  useEffect(() => {
    setIsRecommendationDataEmpty(recommendationsData.length === 0);
  }, [recommendationsData]);

  const InternalPage = () => {
    return (
      <>
        {isInternalPage
          ? recommendationsData?.map((item, index: number) => {
              return (
                <Grid key={index} className={classes.recommendationAccordion}>
                  <Grid>
                    {item?.categoriesData?.map(
                      (category: any, index: number) => {
                        return (
                          <Grid
                            key={index}
                            className={classes.recommendationAccordion}
                          >
                            <RecommendationsCard
                              width="1129px"
                              height=""
                              recommendationsCardHeading={category?.message}
                              recommendationsCardChip={
                                String(category?.additionalData)
                                  .toLowerCase()
                                  .includes('no chip') ? null : (
                                  <Button
                                    label={category?.additionalData}
                                    variant="outlined"
                                    color="primary"
                                    height="33px"
                                    width="auto"
                                    borderRadius="4px"
                                    onClick={() => {
                                      handleOpenChip(category, item?.category);
                                    }}
                                  />
                                )
                              }
                              recommendedActionData={category?.actions}
                            />
                          </Grid>
                        );
                      },
                    )}
                  </Grid>
                </Grid>
              );
            })
          : recommendationsData?.map((item, index: number) => {
              return (
                <Grid key={index} className={classes.recommendationAccordion}>
                  <BasicAccordion
                    title={item?.category}
                    subTitle={item?.categoriesData.length.toString()}
                    width="1177px"
                    // height="52px"
                    content={
                      <Grid>
                        {item?.categoriesData?.map(
                          (category: any, index: number) => {
                            return (
                              <Grid
                                key={index}
                                className={classes.recommendationAccordion}
                              >
                                <RecommendationsCard
                                  width="1129px"
                                  height=""
                                  backgroundColor={
                                    isInternalPage
                                      ? patientAccessTheme.palette.navigationBar
                                          ?.plainBackground
                                      : patientAccessTheme.palette.background
                                          .default
                                  }
                                  recommendationsCardHeading={category?.message}
                                  recommendationsCardChip={
                                    String(category?.additionalData)
                                      .toLowerCase()
                                      .includes('no chip') ? null : (
                                      <Button
                                        label={category?.additionalData}
                                        variant="outlined"
                                        color="primary"
                                        height="33px"
                                        width="auto"
                                        borderRadius="4px"
                                        onClick={() => {
                                          handleOpenChip(
                                            category,
                                            item?.category,
                                          );
                                        }}
                                      />
                                    )
                                  }
                                  recommendedActionData={category?.actions}
                                />
                              </Grid>
                            );
                          },
                        )}
                      </Grid>
                    }
                    borderRadius="8px"
                    rootStyles={{
                      border: '1px solid #E5E9F0',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
                    }}
                  />
                </Grid>
              );
            })}
      </>
    );
  };
  return (
    <Grid>
      {recommendationLoading ? (
        loader
      ) : isRecommendationDataEmpty ? (
        <Grid
          container
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid className={classes.emptyDataIconGrid}>
            <EmptyData />
          </Grid>
          <Grid>
            <Typography
              fontSize="14px"
              fontType="regular"
              lineHeight="24.78px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {messages.emptyData}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <InternalPage />
      )}
      <RecommendationsInternalScreenPopUp
        open={open}
        setOpen={setOpen}
        title=""
      />
    </Grid>
  );
};
export default RecommendationsTab;
